import { ChatsCircleIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const RoundedComment = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <ChatsCircleIcon size={Sizes[size]} {...rest} color={fill} />;
};

RoundedComment.displayName = 'RoundedComment';
